var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pt-3"},_vm._l((_vm.comments),function(comment){return _c('li',{key:comment.id},[_c('VCommentPrint',{attrs:{"message":comment.message,"createdAt":comment.createdAt,"author":comment.author}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }